import React from "react";
import { LEVEL_REQUIREMENTS, getCatcherLevel } from "../../constants/items";

const DepartmentStoreModal = ({
  isOpen,
  toggle,
  storeItems,
  categories,
  activeCategory,
  setActiveCategory,
  filteredItems,
  currency,
  buyAmounts,
  handleQuantityChange,
  handlePurchase,
  loadingItems,
  catcherExp = 0,
  catcherLevel = 0
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="game-popup-overlay"
      onClick={toggle}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 10px',
        boxSizing: 'border-box',
        zIndex: 1050
      }}
    >
      <div 
        className="department-store-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '95%',
          maxWidth: 900,
          maxHeight: '95vh',
          background: 'rgba(29, 34, 46, 0.95)',
          color: '#fff',
          borderRadius: 12,
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          margin: '10px'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '12px 16px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(0, 0, 0, 0.2)',
          flexWrap: 'wrap',
          gap: '8px',
          minHeight: '60px'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            flex: '1 1 auto',
            minWidth: '200px'
          }}>
            <span style={{ fontSize: '20px' }}>🏦</span>
            <h3 style={{ 
              margin: 0, 
              fontSize: '18px', 
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>Department Store</h3>
          </div>
          
          {/* Currency Display - Responsive */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            fontSize: '12px',
            flexWrap: 'wrap',
            flex: '0 1 auto',
            justifyContent: 'flex-end'
          }}>
            {(currency?.money ?? 0) > 0 && (
              <span style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '4px', 
                background: 'rgba(40, 167, 69, 0.2)', 
                padding: '4px 8px', 
                borderRadius: '4px',
                whiteSpace: 'nowrap',
                minWidth: 0,
                overflow: 'hidden'
              }}>
                <img src="/items/money.png" alt="Money" style={{ width: 16, height: 16, flexShrink: 0 }} />
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  ${Number(currency.money || 0).toLocaleString()}
                </span>
              </span>
            )}
            {(currency?.coins ?? 0) > 0 && (
              <span style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '4px', 
                background: 'rgba(255, 193, 7, 0.2)', 
                padding: '4px 8px', 
                borderRadius: '4px',
                whiteSpace: 'nowrap',
                minWidth: 0,
                overflow: 'hidden'
              }}>
                <img src="/items/coin.png" alt="Coins" style={{ width: 16, height: 16, flexShrink: 0 }} />
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {Number(currency.coins || 0).toLocaleString()}
                </span>
              </span>
            )}
          </div>
          
          {/* Close Button - Always Accessible */}
          <button
            onClick={toggle}
            onTouchStart={(e) => {
              e.stopPropagation();
              e.target.style.opacity = '1';
            }}
            onTouchEnd={(e) => {
              e.stopPropagation();
              e.target.style.opacity = '0.7';
            }}
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: '#fff',
              fontSize: '18px',
              cursor: 'pointer',
              padding: '12px',
              borderRadius: '6px',
              opacity: 0.9,
              flexShrink: 0,
              minWidth: '44px',
              height: '44px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '8px',
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0.9'}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{
          padding: '20px',
          overflowY: 'auto',
          flex: 1
        }}>
          {/* Category Tabs */}
          <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
            {(categories || []).map((category, index) => (
              <button
                key={category?.id || index}
                onClick={() => setActiveCategory(category?.id || '')}
                style={{
                  background: activeCategory === (category?.id || '') ? 'rgba(255, 193, 7, 0.8)' : 'rgba(108, 117, 125, 0.6)',
                  border: activeCategory === (category?.id || '') ? '1px solid rgba(255, 193, 7, 0.8)' : '1px solid rgba(108, 117, 125, 0.4)',
                  color: '#fff',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: activeCategory === (category?.id || '') ? 'bold' : 'normal',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (activeCategory !== (category?.id || '')) {
                    e.target.style.background = 'rgba(108, 117, 125, 0.8)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeCategory !== (category?.id || '')) {
                    e.target.style.background = 'rgba(108, 117, 125, 0.6)';
                  }
                }}
              >
                {category?.name || 'Category'}
              </button>
            ))}
          </div>
        
          {loadingItems ? (
            <div style={{ textAlign: 'center', padding: '40px', fontSize: '16px', opacity: 0.8 }}>
              Loading items...
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
              {(filteredItems || []).map(item => {
                const quantity = ((buyAmounts || {})[item.id]) || 1;
                const totalMoneyCost = (item.money || 0) * quantity;
                const totalCoinsCost = (item.coins || 0) * quantity;
                const canAffordMoney = (currency?.money || 0) >= totalMoneyCost;
                const canAffordCoins = (currency?.coins || 0) >= totalCoinsCost;
                const canAfford = canAffordMoney && canAffordCoins;
                
                // Check level requirements for special Pokéballs
                const requiredLevel = LEVEL_REQUIREMENTS[item.id] || 0;
                const meetsLevelRequirement = catcherLevel >= requiredLevel;
                const canPurchase = canAfford && (requiredLevel === 0 || meetsLevelRequirement);

                return (
                  <div key={item.id} style={{
                    background: 'rgba(0, 0, 0, 0.3)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    padding: '12px',
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ flexShrink: 0 }}>
                      <img
                        src={`/${item.image}`}
                        alt={item.name}
                        style={{ width: 40, height: 40, imageRendering: 'pixelated' }}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h6 style={{ margin: '0 0 4px', fontSize: '14px', fontWeight: 'bold', color: '#fff' }}>{item.name}</h6>
                      <p style={{ margin: '0 0 8px', fontSize: '11px', opacity: 0.8, lineHeight: '1.3' }}>{item.description || "No description available."}</p>
                      {item.stackable && (
                        <p style={{ margin: '0 0 8px', fontSize: '10px', color: '#28a745' }}>Stackable (Max: {item.stack_amount || "∞"})</p>
                      )}
                      {requiredLevel > 0 && (
                        <p style={{ 
                          margin: '0 0 8px', 
                          fontSize: '10px', 
                          color: meetsLevelRequirement ? '#28a745' : '#dc3545',
                          fontWeight: 'bold'
                        }}>
                          Required Level: {requiredLevel} {!meetsLevelRequirement && `(Your level: ${catcherLevel})`}
                        </p>
                      )}
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '8px' }}>
                        {(item.money || 0) > 0 && (
                          <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', background: 'rgba(40, 167, 69, 0.2)', padding: '2px 6px', borderRadius: '4px' }}>
                            <img src="/items/money.png" alt="Money" style={{ width: 12, height: 12 }} />
                            ${totalMoneyCost.toLocaleString()}
                          </span>
                        )}
                        {(item.coins || 0) > 0 && (
                          <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', background: 'rgba(255, 193, 7, 0.2)', padding: '2px 6px', borderRadius: '4px' }}>
                            <img src="/items/coin.png" alt="Coins" style={{ width: 12, height: 12 }} />
                            {totalCoinsCost.toLocaleString()}
                          </span>
                        )}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <label style={{ fontSize: '11px', opacity: 0.8 }}>Qty:</label>
                          <input
                            type="number"
                            min="1"
                            max="99"
                            value={quantity}
                            onChange={(e) => handleQuantityChange(item.id, e.target.value)}
                            style={{
                              width: '50px',
                              padding: '2px 4px',
                              background: 'rgba(255, 255, 255, 0.1)',
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              borderRadius: '4px',
                              color: '#fff',
                              fontSize: '11px'
                            }}
                          />
                        </div>
                        <button
                          onClick={() => handlePurchase(item)}
                          disabled={!canPurchase}
                          style={{
                            background: !canPurchase ? 'rgba(108, 117, 125, 0.5)' : 'rgba(74, 144, 226, 0.8)',
                            border: 'none',
                            color: '#fff',
                            padding: '6px 12px',
                            borderRadius: '4px',
                            cursor: !canPurchase ? 'not-allowed' : 'pointer',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            opacity: !canPurchase ? 0.6 : 1
                          }}
                        >
                          {!canAfford ? "Can't Afford" : 
                           (requiredLevel > 0 && !meetsLevelRequirement) ? "Level Locked" : 
                           'Buy'}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepartmentStoreModal;
